import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    loginModal: false,
    signUpModal: false,
    bookingDetail:null,
    bookingModal:false
  },
  reducers: {
    toggleLogin: (state) => {
      state.loginModal = !state.loginModal;
    },

    toggleRegister: (state) => {
      state.signUpModal = !state.signUpModal;
    },

    toggleBookingModal: (state) => {
      state.bookingModal = !state.bookingModal;
    },

    getBookingDetails: (state, action) => {
      state.bookingDetail = action.payload;
    },

    updateBookingDetails: (state, action) => {
      state.bookingDetail.status = action.payload;
    },
    deleteBookingDetails: (state) => {
      state.bookingDetail=null
    },

    // login: (state) => {
    //   state.status = true;
    // },
    // logout: (state) => {
    //   state.status = false;
    // },
  },
});

export const {
  toggleLogin,
  toggleRegister,
  toggleBookingModal,
  getBookingDetails,
  updateBookingDetails,
  deleteBookingDetails
} = authSlice.actions;
export default authSlice.reducer;
